<template>
  <v-container style="overflow: auto;height: 100%" class="principal-body">
    <h3 v-if="showUpload" class="text-center" style="position: relative; top: 30px">
      {{ $t('Upload Invoice') }}
    </h3>
    <v-alert
      v-if="showMessage"
      outlined
      type="warning"
      prominent
      border="left"
      style="margin-top: 35px;"
    >
      {{ $t('ImageInvoice.You cannot use this option due not have a camera device. Use Custom Upload instead!') }}
    </v-alert>
    <v-container v-if="!visibleInformation && !imageUpload" class="camera-modal">
      <div>
        <v-row justify="center">
          <v-col lg="5">
            <video v-if="!show()" ref="video" class="camera-stream" />
            <v-container class="camera-modal-container">
              <v-row justify="center" style="height: 0px">
                <v-col v-if="!show()" cols="12" align="center" style="position: relative; bottom: 170px">
                  <v-btn class="btn-primary" large fab style="margin-top: 20px" @click="capture()">
                    <v-icon color="white">
                      mdi-camera-outline
                    </v-icon>
                  </v-btn>
                </v-col>
              </v-row>
              <v-row justify="center">
                <v-col cols="12" align="center">
                  <label for="camera" class="custom-file-upload">
                    {{ $t('ImageInvoice.UPLOAD') }}
                  </label>
                  <input id="camera" type="file" @change="capturePhoto">
                </v-col>
              </v-row><br><br>
              <div align="center">
                <v-btn class="ml-2" @click="goBack">
                  <v-icon style="margin-right: 5px">
                    mdi-undo-variant
                  </v-icon>{{ $t('Back') }}
                </v-btn>
              </div>
            </v-container>
          </v-col>
        </v-row>
      </div>
    </v-container>
    <v-container v-if="imageUpload" style="margin-top: 10px">
      <Photo :image="image" :pdf="pdf" />
      <v-row justify="center" />
      <v-row justify="center">
        <v-card-actions>
          <v-btn class="justify-center white--text btn-primary" :loading="loading" @click="saveInvoice()">
            <v-icon style="margin-right: 5px">
              mdi-content-save-all
            </v-icon>{{ $t('ImageInvoice.Save Invoice') }}
          </v-btn>
          <v-col>
            <v-btn class="ml-2" @click="tryAgain()">
              <v-icon style="margin-right: 5px">
                mdi-undo-variant
              </v-icon>{{ $t('ImageInvoice.Retry') }}
            </v-btn>
          </v-col>
        </v-card-actions>
      </v-row>
    </v-container>
    <div v-if="visibleInformation">
        {{mode}}
      <v-row justify="center">
        <v-col cols="11">
          <v-form
            ref="form"
            v-model="valid"
          >
            <Photo class="pointer" :image="image" :pdf="pdf" />
            <h4>
              {{ $t('createInvoice.nifPayer') }}
            </h4>
            <v-select
              v-model="cif_payer"
              :disabled="($route.params.idInvoice && !invoiceTypeClient) || (mode!== null && mode=== 1)"
              :placeholder="labelText"
              :items="usersName"
              :rules="rules.cifSet"
            />
            <v-btn v-if="!$route.params.idInvoice || invoiceTypeClient" text color="#00E5FF" @click="modalContact = modalContact2 = true">
              {{ $t('+ Add Contact') }}
            </v-btn>

            <h4>{{ $t('createInvoice.nifReceiver') }}</h4>
            <v-select
              v-model="cif_receiver"
              :disabled="( $route.params.idInvoice && invoiceTypeClient ) || (mode!== null && mode=== 0)"
              :placeholder="labelText"
              :items="usersName"
              :rules="rules.cifSet"
            />
            <v-btn v-if="!$route.params.idInvoice || !invoiceTypeClient" text color="#00E5FF" @click="modalContact = true">
              {{ $t('+ Add Contact') }}
            </v-btn>
            <v-dialog
              ref="dialog"
              v-model="modalContact"
              width="320px"
            >
              <v-form v-model="valid" style="background-color: white;">
                <v-text-field
                  v-model="contactName"
                  :label="$t('Contact Name')"
                  append-icon="mdi-account"
                  style="margin-left: 20px; margin-right: 20px; width: 280px;"
                  :rules="rules.name"
                />

                <v-text-field
                  v-model="contactNIF"
                  :label="$t('Contact NIF/CIF')"
                  append-icon="mdi-passport"
                  style="margin-left: 20px; margin-right: 20px; width: 280px"
                  :rules="rules.cif"
                />

                <v-text-field
                  v-model="contactEmail"
                  :label="$t('Contact Email')"
                  append-icon="mdi-email"
                  style="margin-left: 20px; margin-right: 20px; width: 280px"
                  :rules="rules.email"
                />

                <v-text-field
                  v-model="contactPhone"
                  :label="$t('Contact phone')"
                  append-icon="mdi-phone"
                  style="margin-left: 20px; margin-right: 20px; width: 280px"
                  :rules="rules.phone"
                />
                <v-btn :disabled="!valid" style="margin-left: 90px" text color="primary" @click="addContact()">
                  {{ $t('ADD CONTACT') }}
                </v-btn>
              </v-form>
            </v-dialog>
            <h4>{{ $t('Invoice number') }}</h4>
            <v-text-field
              ref="formNumber"
              v-model="number"
              :placeholder="$t('Invoice number')"
              name="value"
              :rules="rules.value"
              @change="calculateComissions"
            />
            <h4>{{ $t('ImageInvoice.Value') }}</h4>
            <v-text-field
              ref="formValue"
              v-model="amount"
              :placeholder="$t('ImageInvoice.Value')"
              name="value"
              type="number"
              :rules="rules.value"
              @change="calculateComissions"
            />
            <h4>{{ $t('ImageInvoice.Invoice Date') }}</h4>
            <v-dialog
              ref="dialog"
              v-model="modal"
              :return-value.sync="date"
              persistent
              width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  ref="invoiceDate"
                  v-model="date"
                  :label="$t('ImageInvoice.Invoice Date')"
                  append-icon="mdi-calendar-blank"
                  :rules="rules.value"
                  readonly
                  v-on="on"
                />
              </template>
              <v-date-picker v-model="date" scrollable>
                <v-spacer />
                <v-btn text color="#FF6961" @click="modal = false">
                  {{ $t('Cancel') }}
                </v-btn>
                <v-btn text color="primary" @click="$refs.dialog.save(date)">
                  {{ $t('OK') }}
                </v-btn>
              </v-date-picker>
            </v-dialog>
            <h4>{{ $t('Due Date') }}</h4>
            <v-dialog
              ref="dialogPayment"
              v-model="modalPayment"
              :return-value.sync="dueDate"
              persistent
              width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  ref="dueDate"
                  v-model="dueDate"
                  :label="$t('Due Date')"
                  append-icon="mdi-calendar-blank"
                  :rules="rules.value"
                  readonly
                  v-on="on"
                />
              </template>
              <v-date-picker v-model="dueDate" scrollable>
                <v-spacer />
                <v-btn text color="#FF6961" @click="modalPayment = false">
                  {{ $t('Cancel') }}
                </v-btn>
                <v-btn text color="primary" @click="$refs.dialogPayment.save(dueDate)">
                  {{ $t('OK') }}
                </v-btn>
              </v-date-picker>
            </v-dialog>
          </v-form>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-card-actions class="justify-center">
          <v-container>
            <v-row justify="center">
              <v-col cols="12" align="center">
                <v-btn :disabled="!valid" :loading="loading" x-large style="padding: 15px 75px; bottom: 25px" class="justify-center btn-primary white--text" color="#2962FF" @click="updateInvoice()">
                  <v-icon style="margin-right: 5px">
                    mdi-content-save-all
                  </v-icon>{{ $t('Save') }}
                </v-btn>
              </v-col>
            </v-row>
            <v-row justify="center">
              <v-col cols="12" align="center">
                <v-btn class="ml-2" x-large style="padding: 15px 75px; bottom: 25px" text @click="noInfo()">
                  <v-icon style="margin-right: 5px">
                    mdi-undo-variant
                  </v-icon>{{ $t('Back') }}
                </v-btn>
              </v-col>
            </v-row>
          </v-container>
        </v-card-actions>
      </v-row>
    </div>
  </v-container>
</template>
<script>
import ApiRepository from "../repositories/ApiRepository";
import Constants from "../../constants";
import Photo from "./InvoiceResizeImage";
import Vue from 'vue';

export default {
    name: "ImageInvoice",
    components: {
        Photo
    },
    data () {
        return {
            otherNotUsers: [],
            otherUsers: [],
            usersList: [],
            usersName: [],
            pdf: false,
            valid: true,
            valid2: false,
            file: null,
            date: null,
            contactName: null,
            contactNIF: null,
            contactEmail: "",
            contactPhone: "",
            dueDate: null,
            invoice: null,
            modal: null,
            modalContact: null,
            modalContact2: null,
            modalPayment: null,
            color: "primary",
            colorP: "primary",
            colorC: "primary",
            visibleInformation: false,
            receiver: null,
            imageUpload: false,
            payer: null,
            amount: null,
            cif_other: null,
            cif_receiver: null,
            cif_payer: undefined,
            mail_other: '',
            number: null,
            showMessage: false,
            image: null,
            factorComission: null,
            payerComission: null,
            invoiceFile: null,
            invoiceTypeClient: false,
            createChat: false,
            rules: {
                name: [v => !!v || this.$t('A name is required'), ],
                value: [v => !!v || this.$t('The value field is required'), ],
                number: [v => !!v || this.$t('The phone field is required'), ],
                phone: [ v => /^(\+?[\d ]{9,}|)$/.test(v) || this.$t('The phone must be valid') ],
                email: [ v => (/.+@.+\..+/.test(v) || v === "") || this.$t('The mail must be valid.') ],
                cif: [
                    v => !!v || this.$t('A cif is required'),
                    //v => /^[a-zA-Z0-9]{1}[0-9]{7}[a-zA-Z0-9]{1}$/.test(v) || v === '' || this.$t('The CIF must be valid (Example formats: A12345678, 12345678B, C1234567D)'),
                    v => (v !== null && v.toUpperCase() !== this.$user.cif.toUpperCase()) || this.$t('Error.The CIF must be different than yours.')
                ],
                cifSet: [v => (this.cif_receiver !== null || this.cif_payer !== null) || this.$t('A cif is required'), ]
            },
            video: {},
            canvas: {},
            captures: [],
            mediaDevice: false,
            mediaStream: null,
            loading: false,
            showUpload: true,
            mode: null
        };
    },
    computed: {
        labelText () {
            return (this.payer ? this.$t('ImageInvoice.Provider NIF/CIF') : this.$t('ImageInvoice.Client NIF/CIF'));
        },
        cssProps () {
            return {
                '--primary-color': this.$vuetify.theme.primary
            };
        }
    },
    watch: {
        invoiceTypeClient: function isActive (val) {
            if (val) {
                this.imReceiver();
            } else {
                this.imPayer();
            }
        },
        cif_receiver: function (newVal, oldVal) {
            if ((oldVal === null && newVal !== null) || this.cif_payer === null) {
                this.cif_other = newVal;
                this.cif_payer = null;
                this.invoiceTypeClient = false;
                this.$refs.form.validate();
                this.$refs.formValue.reset();
                this.$refs.dueDate.reset();
                this.$refs.formNumber.reset();
                this.$refs.invoiceDate.reset();
            }
        },
        cif_payer: function (newVal, oldVal) {
            if ((oldVal === null && newVal !== null) || this.cif_receiver === null) {
                this.cif_other = newVal;
                this.cif_receiver = null;
                this.invoiceTypeClient = true;
                this.$refs.form.validate();
                this.$refs.formValue.reset();
                this.$refs.dueDate.reset();
                this.$refs.formNumber.reset();
                this.$refs.invoiceDate.reset();
            }
        }
    },
    mounted () {
        if (this.$route.params.byppay && this.$route.params.byppay === Constants.BYPPAY_IDENTIFIER) {
            this.invoiceTypeClient = true;
        }
        if (this.$route.params.createChat) {
            this.createChat = true;
        }
        if (this.$route.params.otherMembers) {
            this.otherUsers = JSON.parse(this.$route.params.otherMembers);
        }
        this.fetch();
    },
    created () {
        if (this.$route.params.mode !== null) {
            this.mode = this.$route.params.mode;
        }
        this.getUsers();
        this.imPayer();
    },
    destroyed () {
        if (this.mediaDevice) {
            const tracks = this.mediaStream.getTracks();
            tracks.map(track => track.stop());
        }
    },
    methods: {
        async getUsers () {
            await ApiRepository.getContacts(this.$user.cif).then(async (res) => {
                if (this.$route.params.idInvoice) {
                    const res = await ApiRepository.getInvoiceById(this.$route.params.idInvoice);
                    if (res.data.invoice) {
                        this.invoiceTypeClient = res.data.invoice.payer._id.toString() === this.$user._id.toString();
                    }
                    this.otherNotUsers = [{cif: res.data.invoice.payer.cif}, {cif: res.data.invoice.receiver.cif}];
                }

                this.usersList = res.data.contacts;
                this.usersName = [];
                this.usersName.push({text: "None", value: null});
                for (const user of this.usersList) {
                    let text = "";
                    if (user.name) {
                        text += user.name;
                    }
                    if (user.cif) {
                        if (text !== "") {
                            text += ", ";
                        }
                        text += user.cif;
                    }
                    if (user.email) {
                        if (text !== "") {
                            text += ", ";
                        }
                        text += user.email;
                    }
                    // console.log(this.otherUsers);
                    const exist = this.otherUsers.find(e => e.cif.toLowerCase() === user.cif.toLowerCase());
                    const existInNotUsers = this.otherNotUsers.find(e => e.cif.toLowerCase() === user.cif.toLowerCase());
                    if (exist || this.otherUsers.length === 0) {
                        if (!existInNotUsers) {
                            this.usersName.push({text: text, value: user._id, user});
                        }
                    }
                }
                if ( this.invoiceTypeClient || (this.mode !== null && this.mode === 0)) {
                    this.cif_payer = this.usersName[1].value;
                } else {
                    this.cif_receiver = this.usersName[1].value;
                }
            })
                .catch((err) => {
                    console.log("ERROR: " + err);
                });
        },
        fetch ()  {
            if (!this.show()) {
                navigator.mediaDevices.getUserMedia({video: { facingMode: { ideal: "environment" } }})
                    .then(mediaStream => {
                        this.mediaDevice = true;
                        this.mediaStream = mediaStream;
                        this.$refs.video.srcObject = mediaStream;
                        this.$refs.video.play();
                    })
                    .catch(() => {});
            }
        },
        async capture () {
            if (this.mediaDevice) {
                const mediaStreamTrack = this.mediaStream.getVideoTracks()[0];
                const imageCapture = new window.ImageCapture(mediaStreamTrack);
                this.imageUpload = !this.imageUpload;
                const photo = await imageCapture.takePhoto();
                this.file = photo;
                this.file = new File([photo], "my_image.png", {type: "image/png", lastModified: new Date()});
                this.createImage(photo);
                this.showUpload = false;
                if (!this.show()) {
                    this.cleanDevices();
                }

            } else {
                this.showMessage = !this.showMessage;
            }
        },
        saveInvoice () {
            this.loading = true;
            this.$root.$emit('start-loading');
            ApiRepository.saveDbImage(this.file)
                .then((res) => {
                    const extension = this.file.name.split('.').pop().toLowerCase();
                    this.invoice = res.data.invoice;
                    this.invoiceFile = res.data.file.filename;
                    this.visibleInformation = true;
                    this.imageUpload = false;
                    const file = new File([this.file], res.data.file._id + "." + extension, {type: this.file.type, lastModified: new Date()});
                    ApiRepository.savePublic(file).then(() => {
                        if (!this.show()) {
                            this.cleanDevices();
                        }
                    }).catch((err) => {
                        console.log("ERROR: " + err);
                    }).finally(() => {
                        this.loading = false;
                        this.$root.$emit('stop-loading');
                    });
                })
                .catch((err) => {
                    console.log("ERROR: " + err);
                });
        },
        imReceiver () {
            this.receiver = !this.receiver;
            this.payer = false;
        },
        imPayer () {
            this.payer = !this.payer;
            this.receiver = false;
        },
        noInfo () {
            this.payer = this.receiver = null;
            this.color = this.colorC = this.colorP = "primary";
            this.$router.push({name: 'invoiceChats', replace: true});
        },
        calculateComissions () {
            ApiRepository.getFactorComission()
                .then((res) => {
                    this.factorComission = this.value * res.data.factorComission;
                    this.factorComission = this.factorComission.toFixed(2);

                    ApiRepository.getPayerComission()
                        .then((response) => {
                            this.payerComission = this.value * response.data.payerComission;
                            this.payerComission = this.payerComission.toFixed(2);
                        })
                        .catch((err) => {
                            let missatge = "";
                            if (err.response.data.errorCode === Constants.ERRORS.ERROR_EXISTING_INVOICE) {
                                missatge = this.$t('ERROR: Something went wrong');
                            } else if (err.response.data.errorCode === Constants.ERRORS.ERROR_SAVING_INVOICE) {
                                missatge = this.$t('ERROR: The invoice couldn\'t be saved, try again');
                            }
                            this.$root.$emit('show-snackbar', {message: missatge, color: 'error'});
                            this.$emit('error');
                            console.error(err);
                        });
                })
                .catch((err) => {
                    let missatge = "";
                    if (err.response.data.errorCode === Constants.ERRORS.ERROR_EXISTING_INVOICE) {
                        missatge = this.$t('ERROR: Something went wrong');
                    } else if (err.response.data.errorCode === Constants.ERRORS.ERROR_SAVING_INVOICE) {
                        missatge = this.$t('ERROR: The invoice couldn\'t be saved, try again');
                    }
                    this.$root.$emit('show-snackbar', {message: missatge, color: 'error'});
                    this.$emit('error');
                    console.error(err);
                });
        },
        updateInvoice () {
            this.loading = true;
            let otherUser;
            if (this.cif_other.value) otherUser = this.usersName.find(element => element.value === this.cif_other.value);
            else otherUser = this.usersName.find(element => element.value === this.cif_other);
            if (otherUser === undefined) {
                this.$root.$emit('show-snackbar', {message: this.$t('Error.Something went wrong'), color: 'error'});
            } else {
                this.mail_other = otherUser.user.email;
                this.cif_other = otherUser.user.cif;
                ApiRepository.createInvoicePhoto(this.invoice._id, this.number, this.amount, this.cif_other, this.factorComission, this.payerComission, this.payer, this.receiver, this.date, this.dueDate, this.mail_other)
                    .then((ret) => {
                        this.$root.$emit('stop-loading');
                        this.$root.$emit('show-snackbar', {
                            message: this.$t('ImageInvoice.Invoice Update Successfully'),
                            color: 'success'
                        });
                        if (this.$route.params.chatId && this.$route.params.chatId !== "" && !this.$route.params.idInvoice) {
                            this.$router.push({
                                name: 'Chat',
                                query: {
                                    chatId: this.$route.params.chatId,
                                    createdInvoice: ret.data.invoice._id,
                                },
                                replace: true
                            });
                        } else
                        if (this.$route.params.chatId && this.$route.params.chatId !== "" && this.$route.params.idInvoice && this.$route.params.idInvoice !== "") {
                            this.$router.push({
                                name: 'Chat',
                                query: {
                                    chatId: this.$route.params.chatId,
                                    createdInvoice: ret.data.invoice._id,
                                    createByppass: true
                                },
                                replace: true
                            });
                        } else if (this.$route.params.idInvoice) {
                            this.$router.push({
                                name: 'CompensationSteper',
                                params: {invoiceId: this.$route.params.idInvoice}
                            });
                        } else if (this.createChat) {
                            ApiRepository.createChat(this.$user._id, ret.data.invoice._id)
                                .then((res) => {
                                    this.$router.push({
                                        name: 'Chat',
                                        query: {
                                            chatId: res.data.chat._id,
                                            invoiceId: ret.data.invoice._id,
                                        },
                                        replace: true
                                    });
                                });
                        } else {
                            this.$router.push({
                                name: 'viewInvoice',
                                query: {invoiceId: this.invoice._id},
                                replace: true
                            });
                        }

                    })
                    .catch((err) => {
                        this.$root.$emit('stop-loading');
                        this.$root.$emit('show-snackbar', {message: this.$t('Error.Something went wrong'), color: 'error'});
                        console.log(err);
                    });
            }
        },
        capturePhoto (e) {
            this.$root.$emit('start-loading');
            const files = e.target.files || e.dataTransfer.files;
            if (!files.length) {
                return;
            }
            if (files[0].type === "application/pdf") {
                this.pdf = true;
                this.widthImage = this.heightImage * 0.7; // 0.7 is the aspect ratio of A4 due a bug in vue-pdf we must set the with supposing that tha invoice is an A4
            }
            this.file = files[0];
            this.createImage(files[0]);
            this.$root.$emit('stop-loading');
            //this.cleanDevices();

        },
        createImage (file) {
            const reader = new FileReader();

            reader.onload = (e) => {
                this.image = e.target.result;
            };
            reader.readAsDataURL(file);
            this.imageUpload = true;
            this.showMessage = false;
            this.showUpload = false;
        },
        async addContact () {
            let contactNameExists = false;
            let contactNIFExists = false;
            let contactEmailExists = false;

            for (const user of this.usersList) {
                if (user.name === this.contactName) contactNameExists = true;
                if (this.contactNIF !== null && user.cif === this.contactNIF) contactNIFExists = true;
                if (user.email === this.contactEmail) contactEmailExists = true;
            }

            if (contactNameExists) {
                this.$root.$emit('show-snackbar', {message: this.$t('Name duplicated'), color: "error"});
            } else if (contactNIFExists) {
                this.$root.$emit('show-snackbar', {message: this.$t('NIF duplicated'), color: "error"});
            } else if (contactEmailExists) {
                this.$root.$emit('show-snackbar', {message: this.$t('Email duplicated'), color: "error"});
            } else {
                const contact = {
                    cif: this.contactNIF,
                    name: this.contactName,
                    email: this.contactEmail
                };
                await ApiRepository.addContact(this.$user.cif, contact).then((ret) => {
                    this.modalContact = false;
                    const exist = this.otherUsers.find(e => e.cif.toLowerCase() === ret.data.contact.cif.toLowerCase());
                    if (exist || this.otherUsers.length === 0) {
                        if (this.modalContact2 === true) {
                            this.modalContact2 = false;
                            this.cif_payer = ret.data.contact._id;
                        } else {
                            this.cif_receiver = ret.data.contact._id;
                        }
                    }
                    this.contactName = null;
                    this.contactNIF = null;
                    this.contactEmail = null;
                    this.$root.$emit('show-snackbar', {message: this.$t('Contact added successfully!'), color: "success"});
                    this.getUsers();
                    this.cif_other = ret.data.contact._id;
                }).catch((e) => {
                    this.$root.$emit('show-snackbar', {message: this.$t('Contact don\'t added successfully!'), color: "error"});
                });
            }
        },
        tryAgain () {
            this.imageUpload = !this.imageUpload;
            this.widthImage = 350;
            this.heightImage = 400;
            this.fetch();
        },
        setSizes ( ) {
            const img = this.$refs.previewImg;

            if (img) {
                const ratio = img.naturalWidth / img.naturalHeight;
                let width = img.clientHeight * ratio;
                let height = img.clientHeight;
                if (width > img.clientWidth) {
                    width = img.clientWidth;
                    height = img.clientWidth / ratio;
                }
                this.widthImage = (width * 400) / 450;
                this.heightImage = height;
            }
        },
        isIOS () {
            const userAgent = navigator.userAgent || navigator.vendor || window.opera;
            return /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
        },
        isFirefox () {
            return navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
        },
        show () {
            return this.isIOS() || this.isFirefox();
        },
        cleanDevices () {
            const tracks = this.mediaStream.getTracks();
            tracks.map(track => track.stop());
        }, goBack () {
            this.$router.push({name: 'invoiceChats', replace: true});
        },
    }
};
</script>

<style scoped>
  .camera-modal {
    width: 100%;
    max-height: 80%;
    align-self: center;
    top: 0;
    left: 0;
    background-color: transparent;
    z-index: 10;
  }
  .camera-stream {
    width: 100%;
    height: 100%;
    position: relative;
    top: -50px;;
  }

  .take-picture-button {
    display: flex;
  }
  input[type="file"] {
    display: none;
  }
  .custom-file-upload {
    border: none;
    border-radius: 3px;
    background: rgb(78,200,246);
    background: linear-gradient(0deg, rgba(78,200,246,1) 0%, rgba(4,79,251,1) 57%);
    color: white;
    padding: 15px 50px;
    cursor: pointer;
    font-weight: bold;
  }
  .labelClass{
    color: var(--v-label-base);
  }
</style>
